import {useMemo} from "react";
import {Grid} from "@mui/material";
import {isDataportalNode} from "../../../constants/nodes";
import ToolsSelect from "../../tools-select";
import EXTRAS from "../../../utils/extras";
import {canEditNode, canImportData, canManagePersonalDashboards, getIsUserSuperadmin} from "../../../utils/permissions";

const ToolsSelectButton = ({node, user, viewMode, onNavigate}) => {
  const nodeId = useMemo(() => node?.nodeId, [node]);
  const nodeExtras = useMemo(() => EXTRAS.parse(node?.extras), [node]);

  const {EnableDataStore, CkanEnableWrite, SupersetEnabled, CkanBaseUrl, StatsManagerBaseUrl} = nodeExtras;

  const isEasyLoadingVisible =
    nodeId && (isDataportalNode(node) || (EnableDataStore && CkanEnableWrite)) && canImportData(user, nodeId);
  const isTaxonomiesManagerVisible = node && isDataportalNode(node) && getIsUserSuperadmin(user);
  const isDashboardManagerAvailable =
    nodeId &&
    SupersetEnabled &&
    (canEditNode(user, nodeId) || canImportData(user, nodeId) || canManagePersonalDashboards(user, nodeId));
  const isMetadataManagerAvailable =
    nodeId && CkanBaseUrl && (canEditNode(user, nodeId) || canImportData(user, nodeId));
  const isStatsManagerAvailable = nodeId && StatsManagerBaseUrl && canEditNode(user, nodeId);

  return isEasyLoadingVisible ||
    isTaxonomiesManagerVisible ||
    isDashboardManagerAvailable ||
    isMetadataManagerAvailable ||
    isStatsManagerAvailable ? (
    <Grid className="external-tools">
      <ToolsSelect
        node={node}
        nodeId={nodeId}
        isEasyLoadingVisible={isEasyLoadingVisible}
        isTaxonomiesManagerVisible={isTaxonomiesManagerVisible}
        isDashboardManagerAvailable={isDashboardManagerAvailable}
        isMetadataManagerAvailable={isMetadataManagerAvailable}
        isStatsManagerAvailable={isStatsManagerAvailable}
        viewMode={viewMode}
        onNavigate={onNavigate}
      />
    </Grid>
  ) : null;
};

export default ToolsSelectButton;
